var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsPercentCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2804 35.3376L35.9432 17.6748M22.6961 19.8826C22.6961 20.4682 22.4635 21.0298 22.0494 21.4438C21.6354 21.8579 21.0738 22.0905 20.4882 22.0905C19.9027 22.0905 19.3411 21.8579 18.9271 21.4438C18.513 21.0298 18.2804 20.4682 18.2804 19.8826C18.2804 19.2971 18.513 18.7355 18.9271 18.3215C19.3411 17.9074 19.9027 17.6748 20.4882 17.6748C21.0738 17.6748 21.6354 17.9074 22.0494 18.3215C22.4635 18.7355 22.6961 19.2971 22.6961 19.8826ZM35.9432 32.75C35.9432 33.3355 35.7105 33.8971 35.2965 34.3112C34.8824 34.7252 34.3209 34.9578 33.7353 34.9578C33.1498 34.9578 32.5882 34.7252 32.1741 34.3112C31.7601 33.8971 31.5275 33.3355 31.5275 32.75C31.5275 32.1644 31.7601 31.6028 32.1741 31.1888C32.5882 30.7747 33.1498 30.5421 33.7353 30.5421C34.3209 30.5421 34.8824 30.7747 35.2965 31.1888C35.7105 31.6028 35.9432 32.1644 35.9432 32.75Z",
    stroke: "white",
    strokeWidth: 3.31177,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1118 48.5846C39.3054 48.5846 49.1902 38.6998 49.1902 26.5062C49.1902 14.3126 39.3054 4.42773 27.1118 4.42773C14.9182 4.42773 5.03333 14.3126 5.03333 26.5062C5.03333 38.6998 14.9182 48.5846 27.1118 48.5846Z",
    stroke: "white",
    strokeWidth: 3.31177
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsPercentCircle);
export default __webpack_public_path__ + "static/media/hugeicons_percent-circle.6b74985ccb3a1e20c5038f5bfaa3bb50.svg";
export { ForwardRef as ReactComponent };